module.exports = __webpack_public_path__ + "static/iphone-blue-e605b03497d8a7fcbdb6054c36de4bb8.png";